import { useEffect, useRef, useState } from 'react';
import apiService from '../services/apiService';
import { ladeEinstellungen, aendereEinstellungen, useBenutzerEinstellungen } from '../services/benutzerEinstellungen';
import { getFeatures } from '../utils/featuresCache';
import { wirksameDarstellung, wendeDarstellungAn } from '../utils/darstellung';
import { useI18n } from '../utils/i18n';

// #564: Gleicht die Sprache mit den Benutzer-Einstellungen auf dem Server ab.
// #565: ebenso die Darstellung (Modern/Klassisch), siehe unten.
// Rendert nichts und hängt in App.js, also auch unter der Mobilansicht, in
// der der Header fehlt.
//
//   - Nach der Anmeldung einmal laden. Steht dort eine Sprache, gilt sie.
//     Steht dort keine, wird die bisherige (Cookie `uiLanguage` bzw. Browser)
//     einmal übernommen, sonst spränge sie nach dem Update zurück.
//   - Danach wird jede Sprachwahl gespeichert, gleich, wo sie getroffen wurde
//     (Optionen-Menü, Mobil-Einstellungen, später der Einstellungs-Dialog #567).
//
// Das Cookie bleibt der Spiegel für das erste Bild (I18nProvider).
export default function EinstellungenAbgleich() {
  const { lang, setLanguage } = useI18n();
  // Sprache, die der Server gerade kennt; null = Abgleich noch nicht fertig
  const serverSprache = useRef(null);
  const langRef = useRef(lang);
  langRef.current = lang;
  // #565: Vorgabe der Installation; undefined = noch nicht geladen
  const [vorgabe, setVorgabe] = useState(undefined);
  const einstellungen = useBenutzerEinstellungen();

  useEffect(() => {
    let abgebrochen = false;
    (async () => {
      try {
        const health = await apiService.getHealth();
        if (abgebrochen || !health || !health.authenticated || !health.configured) return;
        getFeatures().then((f) => { if (!abgebrochen) setVorgabe((f && f.darstellung) || null); });
        const stand = await ladeEinstellungen();
        if (abgebrochen) return;
        if (stand.sprache) {
          serverSprache.current = stand.sprache;
          if (stand.sprache !== langRef.current) setLanguage(stand.sprache);
        } else {
          const neu = await aendereEinstellungen({ sprache: langRef.current });
          serverSprache.current = neu.sprache || langRef.current;
        }
      } catch (_) {
        // Ohne Server-Stand bleibt die Sprache aus dem Cookie, wie vor #564
      }
    })();
    return () => { abgebrochen = true; };
  }, [setLanguage]);

  // #565: Darstellung anwenden, sobald sie feststeht: mit eigener Wahl sofort,
  // sonst erst mit der Vorgabe. Vorher bleibt, was das Vorab-Skript aus dem
  // Cookie gesetzt hat, sonst sprang die Seite kurz auf Modern.
  useEffect(() => {
    if (!einstellungen) return;
    if (!einstellungen.darstellung && vorgabe === undefined) return;
    wendeDarstellungAn(wirksameDarstellung(einstellungen, vorgabe));
  }, [einstellungen, vorgabe]);

  useEffect(() => {
    if (serverSprache.current === null || lang === serverSprache.current) return;
    serverSprache.current = lang;
    aendereEinstellungen({ sprache: lang }).catch(() => null);
  }, [lang]);

  return null;
}
